"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveName = void 0;
const ethers_1 = require("ethers");
const utils_1 = require("ethers/lib/utils");
const eth_1 = require("../../lib/eth");
const schemas_1 = require("@dcl/schemas");
function getResolverContract(contractAddress, provider) {
    return new ethers_1.ethers.Contract(contractAddress, [
        'function addr(bytes32 node) public view virtual override returns (address payable)'
    ], provider);
}
function resolveName(name) {
    return __awaiter(this, void 0, void 0, function* () {
        const nodehash = (0, utils_1.namehash)(name);
        const connectedProvider = yield (0, eth_1.getConnectedProvider)();
        if (!connectedProvider) {
            throw new Error("Couldn't get connected provider to resolve name");
        }
        const provider = new ethers_1.ethers.providers.Web3Provider(connectedProvider);
        const { chainId } = yield provider.getNetwork();
        let resolverAddress = chainId === schemas_1.ChainId.ETHEREUM_SEPOLIA
            ? '0x8FADE66B79cC9f707aB26799354482EB93a5B7dD'
            : '0x4976fb03c32e5b8cfe2b6ccb31c09ba78ebaba41';
        const resolverContract = getResolverContract(resolverAddress, provider);
        const resolvedAddress = yield resolverContract.addr(nodehash);
        if (resolvedAddress !== ethers_1.ethers.constants.AddressZero) {
            return resolvedAddress;
        }
        return undefined;
    });
}
exports.resolveName = resolveName;
//# sourceMappingURL=utils.js.map